export default {
    url: '/planning',
    template: `
        <div class="col00">
            <ui-view></ui-view>
        </div>
    `,
    abstract: true,
    data: {
        canAccess: (AuthService, PrivilegeService) => {
            return PrivilegeService.canViewPlanning() && PrivilegeService.canViewCourses();
        }
    },
    controller ($state) {
        this.$state = $state;
    }
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/planning/index.js